import Highcharts from "highcharts";
import "highcharts/highcharts-more";
import "highcharts/modules/solid-gauge";
import {
  chartBackgroundColor,
  tierFillColor,
  tierBackgroundColor,
} from "./globals";

interface CustomChartOptions extends Highcharts.ChartOptions {
  custom?: {
    label?: Highcharts.SVGElement;
  };
}

export function chartConfig(
  percentage: number,
  element: HTMLElement,
): Highcharts.Options {
  return {
    chart: {
      renderTo: element,
      backgroundColor: chartBackgroundColor,
      type: "pie",
      margin: [0, 0, 0, 0],
      height: 200,
      events: {
        render(this: Highcharts.Chart) {
          const series = this.series[0];
          const chartOptions = this.options.chart as CustomChartOptions;

          if (!chartOptions.custom) {
            chartOptions.custom = {};
          }

          let customLabel = chartOptions.custom.label;
          const labelText = `<strong>${percentage}%</strong>`;
          const labelFontSize = `${series.center[2] / 8}px`;

          if (!customLabel) {
            customLabel = chartOptions.custom.label = this.renderer
              .label(labelText, 0, 0)
              .css({
                color: "var(--highcharts-neutral-color-100, #000)",
                textAnchor: "middle",
                fontSize: labelFontSize,
              })
              .add();
          } else {
            customLabel.attr({
              text: labelText,
            });
            customLabel.css({
              fontSize: labelFontSize,
            });
          }

          const x = series.center[0] + this.plotLeft;
          const labelHeight = customLabel.attr("height");
          const y =
            series.center[1] +
            this.plotTop -
            (typeof labelHeight === "number" ? labelHeight : 0) / 2;

          customLabel.attr({
            x,
            y,
          });
        },
      },
    } as CustomChartOptions,
    title: {
      text: "",
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        animation: false,
        enableMouseTracking: false,
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        type: "pie",
        name: "Percentage",
        innerSize: "75%",
        data: [
          {
            y: percentage,
            color: tierFillColor,
          },
          {
            y: 100 - percentage,
            color: tierBackgroundColor,
          },
        ],
      },
    ],
  };
}

export function initializeCapabilityLevelDistributionChart(
  element: HTMLElement,
): void {
  const percentageValue = element.dataset.percentage || "0";
  const percentage = parseFloat(percentageValue) || 0;

  const config = chartConfig(percentage, element);
  Highcharts.chart(config);
}

export function initializeCapabilityLevelDistributionCharts(): void {
  const charts: NodeListOf<HTMLElement> = document.querySelectorAll(
    "[data-chart='capability_level_distribution']",
  );

  if (charts) {
    Array.from(charts).forEach((chart) => {
      initializeCapabilityLevelDistributionChart(chart);
    });
  }
}

document.addEventListener(
  "turbo:load",
  initializeCapabilityLevelDistributionCharts,
);
